import React from 'react'
export default function Image__Icon({ size = 24, width = size, height = size, fill, secondaryFill, stroke, secondaryStroke, children }) {
  return (<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24">{children}
<g fill={fill} stroke={stroke} className="nc-icon-wrapper"><path d="M23 0H1a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM10 5a2 2 0 1 1 .001 3.999A2 2 0 0 1 10 5zM4 19l4-6 3 3 4-5 5 8H4z"/></g></svg>)
}
